import * as yup from 'yup'

import { allowedFileType, maxSizeFile } from '@/utils/validatorsUtils'

yup.addMethod(yup.mixed, 'maxSizeFile', function(message) {
  return this.test({
    name: 'maxSizeFile',
    message,
    test: maxSizeFile
  })
})

yup.addMethod(yup.mixed, 'allowedFileType', function(message) {
  return this.test({
    name: 'allowedFileType',
    message,
    test: allowedFileType
  })
})
